import i18n from '@/i18n'
import Layout from '../layout.vue'
import List from './list.vue'
import Edit from './editor.vue'
import { COMPANY_ADMIN_MENU_GROUP_KEY } from '@/constant/company'

const basePath = '/v-admin/candidate-status/management'

export default {
  path: `${basePath}`,
  redirect: `${basePath}/list`,
  component: Layout,
  meta: {
    isAllInclude: true,
    permission: ['PERM_CANDIDATE_STATUS_CHANGE_CAUSE_MANAGERMENT', 'PREMIUM_STATUS_CAUSE_MANAGEMENT'],
    titleI18nKey: 'admin.company.candidateStatusManagement.title',
    menu: {
      get label () {
        return i18n.t('admin.company.candidateStatusManagement.menu')
      },
      group: COMPANY_ADMIN_MENU_GROUP_KEY.RECRUIT
    }
  },
  children: [
    {
      path: `${basePath}/list`,
      component: List,
      meta: {
        isNewPage: true,
        breadcrumb: { hidden: true },
        permission: ['PERM_CANDIDATE_STATUS_CHANGE_CAUSE_MANAGERMENT', 'PREMIUM_STATUS_CAUSE_MANAGEMENT'],
        titleI18nKey: 'admin.company.candidateStatusManagement.title'
      }
    },
    {
      path: `${basePath}/edit/:causeId`,
      component: Edit,
      meta: {
        isNewPage: true,
        isEditMode: true,
        permission: ['PERM_CANDIDATE_STATUS_CHANGE_CAUSE_MANAGERMENT', 'PREMIUM_STATUS_CAUSE_MANAGEMENT'],
        titleI18nKey: 'admin.company.candidateStatusManagement.label.editCandidateStatus'
      }
    },
    {
      path: `${basePath}/add`,
      component: Edit,
      meta: {
        isNewPage: true,
        isEditMode: false,
        permission: ['PERM_CANDIDATE_STATUS_CHANGE_CAUSE_MANAGERMENT', 'PREMIUM_STATUS_CAUSE_MANAGEMENT'],
        titleI18nKey: 'admin.company.candidateStatusManagement.label.addCandidateStatus'
      }
    }
  ]
}
